/**
 * Ensures that all possible cases have been handled in a switch statement or similar construct like if elses.
 * This function should be used in the default case to enforce exhaustiveness.
 *
 * By default it should always throw an error as the parameter should never be different than `never`.
 */
export function exhaustiveCheck(param: never, message = `Unhandled case: ${param}`): never {
  throw new Error(message);
}
